module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/union_activity_en-30d27c3d.png";